import React, { Component } from "react";
import {
  Col,
  Row,
  Nav,
  Card,
  Table,
  Form,
  Button,
  ButtonGroup,
  Breadcrumb,
  InputGroup,
  Dropdown,

} from "@themesberg/react-bootstrap";
import { FormGroup, CardHeader, Media, Input, Modal } from "reactstrap";
import SpinDiv from "../components/SpinDiv";
import { toast } from "react-toastify";
import { addNotice, editNotice } from "../../services/noticeService";

export class EditNotice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.notice.id,
      notice: props.notice,
      edit:false,
      user:JSON.parse(localStorage.getItem('user'))
    };
  }

  componentDidMount() {
    toast.configure({ hideProgressBar: true, closeButton: false });

  }


  


  onSaveNotice = async (e) => {
    e.preventDefault();
    await toast.dismiss();
    const {notice, title } = this.state.notice;
    const { validation } = this.state;
    await this.setState({
      validation: {
        ...validation,
        title: title !== '' && title !== undefined,
        notice: notice !== '' && notice !== undefined,
      },
    });
    if (Object.values(this.state.validation).every(Boolean)) {
      this.saveNotice();
    } else {
      const errors = Object.keys(this.state.validation).filter((id) => {
        return !this.state.validation[id];
      });
      //await toast.configure({hideProgressBar: true, closeButton: false});
      toast.dismiss();
      toast.configure({ hideProgressBar: true, closeButton: false });

      toast(
        <div style={{ padding: "10px 20px" }}>
          <p style={{ margin: 0, fontWeight: "bold", color: "red" }}>Errors:</p>
          {errors.map((v) => (
            <p key={v} style={{ margin: 0, fontSize: 14, color: "red" }}>
              * {this.validationRules(v)}
            </p>
          ))}
        </div>
      )
    }
  };


  validationRules = (field) => {
    if (field === "notice") {
      return "Annoucement Description  is required";
    } else if (field == 'title') {
      return "Announcement title is required"
    } 
  };




  saveNotice = () => {
    this.setState({ saving: true });
    const { notice, id, title } = this.state;
    console.log();
    editNotice({
      title: notice.title,
      notice: notice.notice,
      id: id,

    }).then(
      (res) => {
        console.log(res);
        this.setState({ loading: false, saving: false });
        this.props.saved();
        this.props.toggle();
        this.showToast("Announcement has been updated");
      },
      (err) => {

        if (err) {
          toast.dismiss();
          toast.configure({ hideProgressBar: true, closeButton: false });
          if (err) {
            this.showToastError('An error occured')
          }
          this.setState({ saving: false });
        }
        this.setState({ loading: false });
      }
    );
  };



  showToast = msg => {
    toast(<div style={{ padding: 20, color: "green" }}>{msg}</div>);
  }
  showToastError = (msg) => {
    toast(<div style={{ padding: 20, color: "red" }}>{msg}</div>);
  };


  onChange = (e, state) => {
    const { notice } = this.state

    this.setState({ notice: { ...notice, [state]: e } })

  }

  dateFilter = async (e, state) => {
    await this.setState({ [state]: e })
  }



  toggleEdit = () => {
    this.setState({ edit: !this.state.edit });
  };






  render() {

    const { toggle } = this.props;

    const { saving, edit, notice, user, loading } = this.state;
    return (
      <>
        <Modal
          className="modal-dialog modal-dialog-top"
          isOpen={notice != null}
          toggle={() => !loading && !saving && toggle}
          style={{ maxWidth: 700 }}
        >
          {saving && <SpinDiv text={"Saving..."} />}
          {loading && <SpinDiv text={"loading..."} />}
          <div className="modal-header" style={{ padding: "1rem" }}>
            {user.admin == 1 && <div className="btn-toolbar mb-2 mb-md-0">
              <ButtonGroup>
                {notice && (

                  <Button color={edit ? "secondary" : "success"}
                    onClick={this.toggleEdit}
                    size="sm" variant="outline-primary">
                    {edit ? "Discard Changes" : "Edit Annoucement"}



                  </Button>
                )}
              </ButtonGroup>
            </div>}


            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={toggle}
            ></button>
          </div>
          <Card border="light" className="shadow-sm mb-4">
            <Card.Body className="pb-0">
              <Row>
                <Col md={12} style={{ paddingTop: 15 }}>
                  <Form.Group className="mb-2">
                    <Form.Label style={{ paddingRight: 10 }}>Announcement Title</Form.Label>
                    <Input
                      className="custom-control-input"
                      id="title"
                      disabled={!edit}
                      placeholder='Enter Title'
                      value={notice.title}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "title");
                      }}
                      type="text"
                    />
                  </Form.Group>

                </Col>
              </Row>
              

            
              <Row>
                <Col md={12} style={{ paddingTop: 15 }}>
                  <Form.Group className="mb-2">
                    <Form.Label style={{ paddingRight: 10 }}>Annoucement Body</Form.Label>
                    <Input
                      disabled={!edit}
                      className="custom-control-input"
                      value={notice.notice}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "notice");
                      }}
                      type="textarea"
                    />
                  </Form.Group>

                </Col>

              </Row>
              <Row>

              </Row>
              {user.admin == 1 && <Row style={{ marginTop: "10px" }}>
                <Col md={12}>
                  <div>
                    <Button
                      variant="primary"
                      size="sm"
                      style={{ marginTop: "10px", float: "right" }}
                      disabled={saving}
                      onClick={this.onSaveNotice}
                    >
                      Save
                    </Button>
                    <Button
                      size="sm"
                      variant="transparent"
                      data-dismiss="modal"
                      type="button"
                      disabled={saving}
                      style={{ marginTop: "10px", float: "right" }}
                      onClick={toggle}
                    >
                      {" "}
                      Close
                    </Button>
                  </div>
                </Col>
              </Row>}


            </Card.Body>
          </Card>
        </Modal>
      </>
    );
  }
}

export default EditNotice;
